/**
 * @Description 处理视频文件,获取视频封面,视频时长,视频大小
 * @Author Yesr00
 * @CreatedTime 2025/04/22
 * 引入mixins的页面需要创建两个元素,一个video,ref="video",一个canvas,ref="canvas",style设置 display:none
 * @param file iView before-upload钩子里的file,或者是input type=file的file.不要在on-success中调用
 */
import {uploadFile} from '@/api/index';
export default{
    data(){
        return {
            video_info:{
                name:'',
                duration:0,
                cover:'',
                file_size:''
            }
        }
    },
    methods:{
        onVideoExcute(file){
            
            this.video_info.file_size = this.formatFileSize(file.size);

            const videoUrl = URL.createObjectURL(file);
            this.$refs.video.src = videoUrl;
            this.$refs.video.load();

            this.$refs.video.addEventListener("loadedmetadata", async () => {
                // this.video_info.duration = this.$refs.video.duration;
                const duration = this.$refs.video.duration;
                this.$set(this.video_info,'duration',duration);
                await this.captureFrameAtTime(this.video_info.duration / 2);
            });

            this.$refs.video.addEventListener('error',(err)=>{
                console.log('视频加载失败',err);
            })

            console.log("video_info",this.video_info);
            
        },

        //>获取封面帧,时间可调
        captureFrameAtTime(time) {
            const video = this.$refs.video;
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext("2d");

            video.currentTime = time;
            video.addEventListener("seeked",async () => {
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                const blob = this.dataURLtoFile(canvas.toDataURL(), "image/jpeg");
                const cover = await this.uploadCoverFile(blob);
                this.$set(this.video_info,'cover',cover);
            });
        },

        //>格式化文件大小
        formatFileSize(bytes){
            switch(true){
                case bytes<1024:
                    return bytes + " B";
                case bytes<1024*1024:
                    return (bytes/1024).toFixed(1)+' KB';
                default:
                    return (bytes/(1024*1024)).toFixed(1)+' MB';
            }
        },

        //>Base64封面图转file
        dataURLtoFile(dataURI, type) {
            // console.log('dataURI',dataURI);
            const prefix = dataURI.split(',')[0];
            const mime = prefix.split(';')[0].split(':')[1];
            // console.log('mime',mime);
            const bstr = atob(dataURI.split(',')[1]);
            const u8arr = new Uint8Array(bstr.length);
            for (let i = 0; i < bstr.length; i++) {
                u8arr[i] = bstr.charCodeAt(i);
            }
            const fileName = `cover_${Date.now()}.${mime.split('/')[1]}`;
            return new File([u8arr], fileName, { type: mime });
        },

        //>上传图片到OSS,用以获取存入数据库的封面URl
        async uploadCoverFile(file){
            try{
                console.log('file',file);
                const res = await uploadFile(file,'template');
                this.video_info.cover = res.data.url;
                return res.data.url;
            }catch(err){
                console.log('上传封面失败',err);
            }
        }
    }
}